import { createFileRoute } from "@tanstack/react-router";

import { VerificationSettingsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/verification/settings")({
  component: VerificationSettingsPage,
});
